"use client";

import { c as _c } from "react/compiler-runtime";
import { useController, type Control, type FieldValues, type Path } from "react-hook-form";
import { CheckboxGroupInput, CheckboxGroupInputProps } from "../rac/checkbox-group-input";
type RHFProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  rules?: Record<string, unknown>;
} & Omit<CheckboxGroupInputProps, "value" | "onChange" | "onBlur" | "errorMessage">;
export function CheckboxGroupField(t0) {
  const $ = _c(16);
  let control;
  let name;
  let rest;
  let rules;
  if ($[0] !== t0) {
    ({
      name,
      control,
      rules,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = control;
    $[2] = name;
    $[3] = rest;
    $[4] = rules;
  } else {
    control = $[1];
    name = $[2];
    rest = $[3];
    rules = $[4];
  }
  let t1;
  if ($[5] !== control || $[6] !== name || $[7] !== rules) {
    t1 = {
      name,
      control,
      rules
    };
    $[5] = control;
    $[6] = name;
    $[7] = rules;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const {
    field: t2,
    fieldState: t3
  } = useController(t1);
  const {
    onChange,
    value
  } = t2;
  const {
    error
  } = t3;
  let t4;
  if ($[9] !== onChange) {
    t4 = newValue => {
      onChange(newValue);
    };
    $[9] = onChange;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleChange = t4;
  const t5 = error?.message;
  let t6;
  if ($[11] !== handleChange || $[12] !== rest || $[13] !== t5 || $[14] !== value) {
    t6 = <CheckboxGroupInput {...rest} value={value} onChange={handleChange} errorMessage={t5} />;
    $[11] = handleChange;
    $[12] = rest;
    $[13] = t5;
    $[14] = value;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}